import axios from "axios";
import * as actionTypes from "./actionTypes";
import { loginURL, registerURL } from "../../constants";
import { message } from "antd";
import { openNotificationWithIcon } from "../../containers/Function";
import Cookies from "universal-cookie";
import JsCookies  from 'js-cookie';
const cookies = new Cookies();

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const authSuccess = (token) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token,
  };
};

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error,
  };
};

export const logout = () => {
  // cookies.remove("refresh");
  // cookies.remove("token");
  JsCookies.remove('refresh', { domain: '.rainscales.com.vn' });
  JsCookies.remove('token', { domain: '.rainscales.com.vn' });
  // JsCookies.remove('refresh', { domain: '.dri.io.vn' });
  // JsCookies.remove('token', { domain: '.dri.io.vn' });
  JsCookies.remove('token');
  JsCookies.remove('refresh');
  // Xóa toàn bộ cookies có thể do khởi tạo nhiều
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  // localStorage.removeItem("token");
  // localStorage.removeItem("refresh");
  // localStorage.removeItem("expirationDate");
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

export const checkAuthTimeout = (expirationTime) => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(logout());
      // window.location.href = '/login'
    }, expirationTime * 1000);
  };
};

export const setUserData = (userData) => {
  return {
    type: "SET_USER_DATA",
    payload: userData,
  };
};

export const authLogin = (username, password) => {
  return (dispatch) => {
    dispatch(authStart());
    axios
      .post(loginURL, {
        username: username,
        password: password,
      })
      .then((res) => {
        // debugger
        const token = res.data.access;
        const refresh = res.data.refresh;
        // const expirationDate = new Date(new Date().getTime() + 3600 * 1000);
        // localStorage.setItem("token", token);
        // localStorage.setItem("refresh", refresh);
        // localStorage.setItem("expirationDate", expirationDate);
        if (localStorage.getItem("loginRedirect")) {
          const path = localStorage.getItem("loginRedirect");
          localStorage.clear();
          window.location = path;
          // setLocation(localStorage.getItem('loginRedirect'))
        }

        cookies.set("token", token);
        cookies.set("refresh", refresh);

        // dispatch(setUserData( res.data.access)); // Gọi setUserData action
        dispatch(authSuccess(token));
        dispatch(checkAuthTimeout(5*24*3600)); // 5d
      })
      .catch((err) => {
        if (err.request.status === 0) {
          openNotificationWithIcon(
            "error",
            "Lỗi kết nối",
            "Lỗi kết nối, kiểm tra kết nối tới server !!!"
          );
          // message.error('Lỗi kết nối, kiểm tra kết nối tới server !!!', 10);
        }
        dispatch(authFail(err));
      });
  };
};

export const authSignup = (username, email, password1, password2) => {
  return (dispatch) => {
    dispatch(authStart());
    axios
      .post(registerURL, {
        username: username,
        email: email,
        password1: password1,
        password2: password2,
      })
      .then((res) => {
        const token = res.data.key;
        // const expirationDate = new Date(new Date().getTime() + 3600 * 1000);
        // localStorage.setItem("expirationDate", expirationDate);
        dispatch(authSuccess(token));
        dispatch(checkAuthTimeout(3600));
      })
      .catch((err) => {
        dispatch(authFail(err));
      });
  };
};

export const authCheckState = () => {
  return (dispatch) => {
    const token = cookies.get("token");
    if (token === undefined) {
      dispatch(logout());
    } else {
      // const expirationDate = new Date(localStorage.getItem("expirationDate"));
      // if (expirationDate <= new Date()) {
      //   dispatch(logout());
      // } else {
      dispatch(authSuccess(token));
      // dispatch(
      //   checkAuthTimeout(
      //     (expirationDate.getTime() - new Date().getTime()) / 1000
      //   )
      // );
    }
  };
};
